<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS">
      <el-date-picker
        required
        pastDates
        :disabled="onlyView"
        label="Asmens pripažinimo nežinia kur esančiu data"
        v-model="formData.basis_date"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="(inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA) || (inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA)">
      <el-date-picker
        required
        pastDates
        :disabled="onlyView"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Dokumento, patvirtinančio įgaliojimo pasibaigimą, data' : 'Dokumento, patvirtinančio prokūros pasibaigimą, data'"
        v-model="formData.basis_date"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="4" v-if="isErrorsCorrectionWrongRegistered">
      <el-date-picker
        required
        pastDates
        :disabled="onlyView"
        label="Dokumento, patvirtinančio sprendimą ištaisyti duomenis, data"
        v-model="formData.basis_date"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="5" v-if="isErrorsCorrectionWrongRegistered">
       <el-text-field
          label="Dokumento, patvirtinančio sprendimą ištaisyti duomenis, numeris"
          :disabled="onlyView"
          v-model="formData.change_notarial_no"
          :maxlength="20"
        />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA || inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA || isErrorsCorrectionWrongRegistered">
      <el-autocomplete v-if="!onlyView"
        required
        :disabled="onlyView"
        :items="classifiers['expiration-reason']"
        itemvalue="value"
        itemtext="text"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimas pasibaigė' : 'Prokūra pasibaigė'"
        v-model="formData.expiration_reason_id"
      />
      <el-text-field v-else
        disabled
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimas pasibaigė' : 'Prokūra pasibaigė'"
        :value="formData.expiration_reason_text"
      />
    </v-col>

    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA || inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA">
      <el-date-picker
        required
        pastDates
        :disabled="onlyView"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimo galiojimo sustabdymo data' : 'Prokūros galiojimo sustabdymo data'"
        v-model="formData.basis_date"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA || inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA">
      <el-autocomplete
        required
        :disabled="onlyView"
        :items="classifiers['suspension-reason']"
        itemvalue="value"
        itemtext="text"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimo galiojimas sustabdytas' : 'Prokūros galiojimas sustabdytas'"
        v-model="formData.suspension_reason_id"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA || inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA">
      <el-date-picker
        required
        pastDates
        :disabled="onlyView"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimo galiojimo sustabdymo panaikinimo data' : 'Prokūros galiojimo sustabdymo panaikinimo data'"
        v-model="formData.basis_date"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA || inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA">
      <el-autocomplete v-if="!onlyView"
        required
        :disabled="onlyView"
        :items="classifiers['suspension-reason']"
        itemvalue="value"
        itemtext="text"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimo galiojimo sustabdymas panaikintas' : 'Prokūros galiojimo sustabdymas panaikintas'"
        v-model="formData.suspension_reason_id"
      />
      <el-text-field v-else
        disabled
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimo galiojimo sustabdymas panaikintas' : 'Prokūros galiojimo sustabdymas panaikintas'"
        :value="formData.suspension_reason_text"
      />
    </v-col>
    <v-col style="display: inline-flex;" class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="!userIsNotary && !isErrorsCorrectionWrongRegistered">
      <!-- <el-text-field 
        disabled
        :value="formData.court_name"
        label="Teismas priėmęs sprendimą"
      />
      <el-button
        class="ml-1 "
        style="height: 40px;"
        color="primary"
        title="Ieškoti"
        @click.native.stop="searchCourtData()"
      /> -->
      <el-autocomplete
        required
        :disabled="onlyView"
        :items="classifiers['court']"
        itemvalue="value"
        itemtext="text"
        label="Teismas priėmęs sprendimą"
        v-model="formData.court_id"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="!userIsNotary && !isErrorsCorrectionWrongRegistered">
      <el-date-picker
        required
        pastDates
        :disabled="onlyView"
        label="Teismo sprendimo data"
        v-model="formData.court_decision_date"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="!userIsNotary && !isErrorsCorrectionWrongRegistered">
      <el-text-field
        required
        :disabled="onlyView"
        label="Teismo sprendimo numeris"
        v-model="formData.decision_number"
        :maxlength="50"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3" v-if="showEndNotarialNumber">
      <el-text-field
        required
        :disabled="onlyView"
        label="Notarinio registro numeris"
        v-model="formData.change_notarial_no"
        :maxlength="20"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="6" v-if="showEndNotarialPersonNumber">
      <el-text-field
        required
        :disabled="onlyView"
        label="Pasibaigimo dokumento registracijos numeris"
        v-model="formData.notarial_person_number"
        :maxlength="20"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="9" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA || inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA || isErrorsCorrectionWrongRegistered">
      <el-textarea
        :readonly="onlyView"
        :maxlength="2000"
        label="Pasibaigimo aprašymas"
        v-model="formData.expiration_reason_description"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="9" v-if="(inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA) || (inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA)">
      <el-textarea
        required
        :readonly="onlyView"
        :maxlength="2000"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimo galiojimo sustabdymo aprašymas' : 'Prokūros galiojimo sustabdymo aprašymas'"
        v-model="formData.suspension_reason_description"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="9" v-if="inJournalType == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA || inJournalType == InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA">
      <el-textarea
        required
        :readonly="onlyView"
        :maxlength="2000"
        :label="mandateData.mandate_kind == MandateKinds.NTPI || mandateData.mandate_kind == MandateKinds.ITPSI ? 'Įgaliojimo galiojimo sustabdymo aprašymas' : 'Prokūros galiojimo sustabdymo panaikinimo aprašymas'"
        v-model="formData.suspension_reason_description"
      />
    </v-col>
        <!-- modals -->
     <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      :modalType="modalType"
      @addPersonData="AddPerson"
    />
  </v-row>
</template>

<script>
import Enums from '@/enums'
import InJournalTypes from '@/components/constants/inJournalTypes'
import MandateKinds from '@/components/constants/mandateKind'
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import { classifiersGet } from '@/services/classifierService.js'
import Roles from '@/components/constants/roles'
import ElTextField from '../../../../components/elements/ElTextField.vue'

export default {
  name: 'ProvidedDataForm',
  components: { ModalAddPerson},
  props: {
    formData: [Array, Object],
    mandateData: [Array, Object],
    inJournalType: [String],
    onlyView: Boolean
  },
  created() {
    this.getClassifiers()
  },
  data() {
    return {
      InJournalTypes: InJournalTypes,
      MandateKinds: MandateKinds,
      classifiers: {},
      modalType: null,
      showAddPerson: null,
    }
  },
  computed: {
    isErrorsCorrectionWrongRegistered() {
      return this.inJournalType == InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA
    },
    formatedLogicSelect() {
      return Enums.logicSelect
    },
    userIsNotary() {
      const userRole = this.$store.getters.userRole
      return [Roles.NOTARAS, Roles.KONSULAS, Roles.NOT_PAD, Roles.KAL_VAD, Roles.NOT_PAD2].some((item) => {
        return userRole.includes(item)
      })
    },
    showEndNotarialNumber() {
      const userRole = this.$store.getters.userRole
      return [Roles.NOTARAS, Roles.KONSULAS, Roles.NOT_PAD, Roles.NOT_PAD2].some((item) => {
        return userRole.includes(item)
      }) && this.inJournalType == this.InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA;
    },
    showEndNotarialPersonNumber() {
      const userRole = this.$store.getters.userRole
      return [Roles.KAL_VAD].some((item) => {
        return userRole.includes(item)
      }) && this.inJournalType == this.InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA;
    }
  },
  methods: {
    classifiersGet,
    getClassifiers() {
      let arr = []
      let search = {}
    
       switch (this.inJournalType) {
        case (InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA):
        case (InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA):
          search.key = 'basis-search-like'
          search.value =  'end' 
          arr.push(search)
          break;
        case (InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA):
        case (InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA):
          search.key = 'basis-search-like'
          search.value = 'suspend'
          arr.push(search)
          break;
        case (InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA):
        case (InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA):
          search.key = 'basis-search-like'
          search.value = 'terminate' 
          arr.push(search)
          break;
        default: 
        break;
      }
      

      let requiredClassifiers
      if (this.mandateData && this.mandateData.mandate_kind) {
        let typeValue = this.mandateData.mandate_kind == 'PP' || this.mandateData.mandate_kind == 'ITPSP' ? 'pp' : this.mandateData.mandate_kind
        arr.push({key:'type-search-like', value: typeValue})
        requiredClassifiers = { classifiers: ['expiration-reason','suspension-reason', 'court'], search: arr }
      } else {
        requiredClassifiers = { classifiers: ['court'] }
      }
      classifiersGet(requiredClassifiers)
        .then((res) => this.classifiers = res.data.classifiers)
        .catch((err) => this.$root.$emit('DATA_ERROR', err))
        .finally(() => this.pageloading = false)
    },
    searchCourtData(){
      this.modalType = 'court'
      this.showAddPerson = true
    },
    AddPerson(item) {
      this.formData.court_name = item.fullname
      this.formData.court_id = item.amn_id
      this.showAddPerson = false
    },
  },
}
</script>

<style>
</style>